import { render } from "./Web3View.vue?vue&type=template&id=3c2b5f6c&ts=true"
import script from "./Web3View.vue?vue&type=script&lang=ts"
export * from "./Web3View.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__